import React from 'react';
import { Redirect } from 'react-router-dom';

/**
 * This addresses an issue with Route transitions causing multiple
 * redirects. The wrapped Switch seems to be the suggested way to
 * do these transitions, but it causes a remount which causes extra
 * redirects. I found someone commenting on this, but have yet to
 * find the ideal solution. This seems to work reliably though.
 *
 * I tried using location withRouter to do a location comparison,
 * but that didn't have the updated value yet
 */
export default class RedirectOnce extends React.Component {
  rendered = false;

  componentDidMount() {
    this.rendered = true;
  }

  render() {
    if (!this.rendered) {
      return <Redirect to={this.props.to} />;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/route/RedirectOnce.js